export type SiteAnnouncement = {
  id: number;
  name: string;
  content: string;
  agencyIds?: string[];
  type: SiteAnnouncementType;
  imageUrl?: string;
  attachmentUrls?: string[];
  publishTime: string;
  status: SiteAnnouncementStatus;
  duration: number;
  version: number;
  shouldResend: boolean;
};

export type SiteAnnouncementListDTO = Omit<
  SiteAnnouncement,
  'duration' | 'shouldResend'
> & {
  creator: string;
};

export type SiteAnnouncementImageValue = {
  file?: File;
  url?: string;
  // base64 preview produced by the image file input for a freshly picked file
  imgBase64?: string;
};

export type SiteAnnouncementAttachmentValue = {
  file?: File;
  name: string;
  url?: string;
};

export type SiteAnnouncementFormData = {
  publishTime: string;
  name: string;
  content: string;
  duration: number;
  agencyIds: string[];
  type: SiteAnnouncementType;
  image: SiteAnnouncementImageValue;
  attachments: SiteAnnouncementAttachmentValue[];
  shouldResend: boolean;
  chooseAgencyStrategy: ChooseAgencyStrategy;
};

export type SiteAnnouncementCreateDTO = Omit<
  SiteAnnouncementFormData,
  'chooseAgencyStrategy' | 'shouldResend' | 'image' | 'attachments'
> & {
  imageUrl?: string;
  attachmentUrls?: string[];
};
export type SiteAnnouncementUpdateDTO = {
  id: number;
  shouldResend: boolean;
} & SiteAnnouncementCreateDTO;

export enum SiteAnnouncementStatus {
  ACTIVE = 0,
  PUBLISHED = 1,
  UNPUBLISHED = 2,
  INACTIVE = 3,
  DELETED = 99
}

export enum ChooseAgencyStrategy {
  ALL = 'all',
  PARTIAL = 'partial'
}

export enum SiteAnnouncementType {
  FEATURE_UPDATE = 1,
  SYSTEM_MAINTENANCE = 2,
  POLICY_ANNOUNCEMENT = 3,
  INCIDENT_REPORT = 4,
  GENERAL = 5
}
